import { UPDATESUBMENU } from '../mutation-types'
const state = {
  submenu: 'Index'
}
const mutations = {
  [UPDATESUBMENU] (state, obj) {
    state.submenu = obj
  }
}
export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/index.module.js